import imgAerra81 from "./img-aerra8 (1).webp";
import imgAerra82 from "./img-aerra8 (2).webp";

const imgAerra8 = [imgAerra81, imgAerra82];

export default imgAerra8;
